
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 3H2V11H11V3ZM22 3H13V11H22V3ZM13 13H22V21H13V13ZM11 13H2V21H11V13Z" fill="currentColor"></path></svg>';export default svg;
    